var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterPink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.40039 6.95008V1H14.6003V6.95008",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4 14.6002H2.7C2.24913 14.6002 1.81673 14.4211 1.49792 14.1023C1.17911 13.7835 1 13.3511 1 12.9002V8.65015C1 8.19928 1.17911 7.76687 1.49792 7.44806C1.81673 7.12924 2.24913 6.95013 2.7 6.95013H16.3C16.7509 6.95013 17.1833 7.12924 17.5021 7.44806C17.8209 7.76687 18 8.19928 18 8.65015V12.9002C18 13.3511 17.8209 13.7835 17.5021 14.1023C17.1833 14.4211 16.7509 14.6002 16.3 14.6002H14.6",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6003 11.2H4.40039V18H14.6003V11.2Z",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterPink);
export default __webpack_public_path__ + "static/media/printer-pink.84a7dbafac896ced1e985789f5a60f30.svg";
export { ForwardRef as ReactComponent };